import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import { Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { Panel } = Collapse;


const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl, categoryConfiguration } = props;

  const lastServiceDate = publicData?.lastServiceDate;
  const categorylevel2 = categoryConfiguration?.categories?.find(x => x.id == publicData?.categoryLevel1)?.subcategories?.find(y=> y.id == publicData?.categoryLevel2);
  const productOrBike = categorylevel2?.name;
  const brand = categorylevel2?.subcategories?.find(z => z.id == publicData?.categoryLevel3)?.name;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      {/*<Heading as="h2" rootClassName={css.sectionHeading}>
      Specifications
      </Heading>
      <ul className={css.details}>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>
            { publicData.categoryLevel1 == 'Bikes-And-Framesets' ? 
              intl.formatMessage({ id: 'EditListingDetailsForm.bikeLabel' },)
            : intl.formatMessage({ id: 'EditListingDetailsForm.productLabel' },)}
          </span>
          <span>{productOrBike}</span>
        </li>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>{intl.formatMessage({ id: 'EditListingDetailsForm.brandLabel' })}</span>
          <span>{brand}</span>
        </li>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
        { (publicData.categoryLevel1 == 'Bikes-And-Framesets' && lastServiceDate )?
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>{intl.formatMessage({ id: 'EditListingDetailsForm.lastServiceDate' })}</span>
            <span>{lastServiceDate}</span>
          </li>
        : null }
      </ul>*/}


      <Collapse
    bordered={false}
    expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
  >
    <Panel header="Specifications" key="1" >
    <ul className={css.details}>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>
            { publicData.categoryLevel1 == 'Bikes-And-Framesets' ? 
              intl.formatMessage({ id: 'EditListingDetailsForm.bikeLabel' },)
            : intl.formatMessage({ id: 'EditListingDetailsForm.productLabel' },)}
          </span>
          <span>{productOrBike}</span>
        </li>
        <li className={css.detailsRow}>
          <span className={css.detailLabel}>{intl.formatMessage({ id: 'EditListingDetailsForm.brandLabel' })}</span>
          <span>{brand}</span>
        </li>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
        { (publicData.categoryLevel1 == 'Bikes-And-Framesets' && lastServiceDate )?
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>{intl.formatMessage({ id: 'EditListingDetailsForm.lastServiceDate' })}</span>
            <span>{lastServiceDate}</span>
          </li>
        : null }
      </ul>
    </Panel>
  </Collapse>


    </section>
  ) : null;
};

export default SectionDetailsMaybe;
